import { Box, IconButton, styled } from "@mui/material";

/**
 * The editor's two columns: article and assistant. `position: relative` is what
 * the assistant floats against when it collapses on a narrow viewport, and
 * `min-height: 0` is what lets each column scroll on its own instead of pushing
 * the page into one long scroll that takes the composer off screen with it.
 */
export const BodyWrapper = styled(Box)`
  position: relative;
  display: flex;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  padding-block-end: 12px;
`;

/**
 * Article column. It owns its scrollbar, so the toolbar has to be pinned or it
 * would slide away from the text it acts on.
 */
export const EditorColumn = styled(Box)`
  flex: 1;
  min-width: 0;
  overflow-y: auto;

  & .mdxeditor-toolbar {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  /* Room to breathe under the last line — the final paragraph shouldn't sit
     flush against the frame while typing. */
  & .mui-mdx-editor {
    padding-block-end: 120px;
  }
`;

export const InfoButton = styled(IconButton)`
  position: absolute;
  top: -50px;
  right: 0px;
  z-index: 100;
`;
